import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LoginRequest } from './login.types';

import { requestLogin } from './login.actions';

export const useLoginApi = () => {
  const dispatch = useDispatch();

  const login = useCallback(
    (requestData: LoginRequest, onSuccess?: () => void) => {
      dispatch(requestLogin({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { login };
};
